import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { APIService } from '../.././../shared/service/apiService.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  signUpForm: FormGroup;
  isLoading = false;
  submitted = false;
  successMessage = '';
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private apiService: APIService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.signUpForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName:  ['', [Validators.required, Validators.minLength(2)]],
      email:     ['', [Validators.required, Validators.email]],
      roles:     ['student', Validators.required],
    });
  }

  get f() { return this.signUpForm.controls; }

  onSubmit(): void {
    this.submitted = true;
    this.errorMessage = '';
    this.successMessage = '';

    if (this.signUpForm.invalid) { return; }

    this.isLoading = true;

    const payload = {
      firstName: this.f['firstName'].value.trim(),
      lastName:  this.f['lastName'].value.trim(),
      email:     this.f['email'].value.trim().toLowerCase(),
      roles:     this.f['roles'].value,
    };

    this.apiService.adminCreateUser(payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.successMessage =
          'Cuenta creada con éxito. Se ha enviado un correo para activar la cuenta y establecer la contraseña.';
        this.signUpForm.reset();
        this.submitted = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage =
          err?.error?.message || 'Ocurrió un error al crear la cuenta. Intenta de nuevo.';
      }
    });
  }

  goToSignIn(): void {
    this.router.navigate(['/auth/sign-in']);
  }
}
